import React from "react";
import { Button, Table } from "reactstrap";

const getLicenseStatusBadge = (license) => {
  if (license.active) {
    return <span className="badge badge-success">Active</span>;
  } else if (license.expired) {
    return <span className="badge badge-danger">Expired</span>;
  } else {
    return <span className="badge badge-warning">Pending</span>;
  }
};

const LicensesTable = ({
  licenses,
  loading,
  actionLoading,
  onCreateClick,
  onRenew,
  onDelete,
}) => {
  return (
    <>
      <hr />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-0">Licenses</h6>
        {onCreateClick && (
          <Button color="primary" size="sm" onClick={onCreateClick} disabled={!!actionLoading}>
            + Create License
          </Button>
        )}
      </div>

      {loading ? (
        <div className="text-center py-3">
          <span className="spinner-border spinner-border-sm me-2"></span>
          Loading licenses...
        </div>
      ) : licenses.length === 0 ? (
        <div className="text-center text-muted py-3">No licenses found</div>
      ) : (
        <Table size="sm" bordered responsive>
          <thead>
            <tr>
              <th>Level</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {licenses.map((license) => (
              <tr key={license.uuid}>
                <td>
                  <span className="badge badge-info">
                    {license.levelDisplayName || license.level}
                  </span>
                </td>
                <td>{license.startDate}</td>
                <td>{license.endDate}</td>
                <td>{getLicenseStatusBadge(license)}</td>
                <td>
                  <div className="d-flex gap-1">
                    {onRenew && (
                      <Button
                        color="warning"
                        size="sm"
                        outline
                        onClick={() => onRenew(license)}
                        disabled={!!actionLoading}
                        title="Renew license"
                      >
                        Renew
                      </Button>
                    )}
                    {onDelete && (
                      <Button
                        color="danger"
                        size="sm"
                        outline
                        onClick={() => onDelete(license)}
                        disabled={!!actionLoading}
                        title="Delete license"
                      >
                        Delete
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default LicensesTable;
